<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">{{ $t('B0300.titles[0]') }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!valid"
          @click="search"
          class="btn-search"
          v-permit.SHARP_INV_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-btn @click="toPaid" small v-permit.SHARP_INV_NEW>{{
          $t('app.buttons.paidNew')
        }}</v-btn>
        <v-btn @click="toUnpaid" small v-permit.SHARP_INV_NEW>{{
          $t('app.buttons.unpaidNew')
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          small
          v-permit.SHARP_INV_UPDATE
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length === 0 || !canDelete"
          @click="remove"
          small
          v-permit.SHARP_INV_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >
        <v-btn @click="exportCsv" small v-permit.SHARP_INV_CSV_DOWNLOAD>{{
          $t('app.buttons.csvExport')
        }}</v-btn>
        <v-btn
          :disabled="selected.length === 0"
          @click="exportInvoicePl"
          small
          v-permit.SHARP_INV_CSV_DOWNLOAD
          >{{ $t('B0300.buttons.download') }}</v-btn
        >
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_PARTNER'
                )
              "
              xs3
            >
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                item-text="text"
                item-value="value"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <!-- OK -->
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.ivNo')"
                clearable
                v-model="query.invoiceNo"
              />
            </v-flex>
            <!-- OK -->
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.poNo')"
                clearable
                v-model="query.poNo"
              />
            </v-flex>
            <!-- OK -->
            <v-flex xs3>
              <v-text-field
                :label="$t('app.labels.lotNo')"
                clearable
                v-model="query.lotNo"
              />
            </v-flex>
            <!-- OK -->
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                url="ports/kv"
                v-model="query.loadingPortCode"
              />
            </v-flex>
            <!-- OK -->
            <v-flex md3 sm6 xs12>
              <remote-select
                :label="$t('app.labels.transportMode')"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              />
            </v-flex>
            <!-- OK -->
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.scWarehouse')"
                url="warehouses/sc-kv"
                v-model="query.scWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <!-- OK -->
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.warehouseKeeper')"
                url="employees/kv"
                v-model="query.warehouseKeeperId"
              ></remote-autocomplete>
            </v-flex>
            <!-- 没有数据无法测试 -->
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              />
            </v-flex>
            <!-- OK -->
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.incoterm')"
                item-text="code"
                url="incoterms/kv"
                v-model="query.incotermId"
              />
            </v-flex>
            <!-- OK -->
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :label="$t('app.labels.etd')"
                    :max="query.etdTo"
                    v-model="query.etdFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etdFrom"
                    v-model="query.etdTo"
                  ></date-input>
                </v-flex>
                <!-- OK -->
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :label="$t('app.labels.creationDate')"
                    :max="query.creatingDateTo"
                    v-model="query.creatingDateFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.creatingDateFrom"
                    v-model="query.creatingDateTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- OK -->
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.currency')"
                url="currencies/kv"
                v-model="query.currencyCode"
              />
            </v-flex>
            <!-- OK -->
            <v-flex md3 sm6 xs12>
              <v-select
                :items="usage"
                clearable
                item-text="text"
                item-value="value"
                label="使用状況"
                v-model="query.isUsed"
              ></v-select>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-select
                :items="payment"
                clearable
                item-text="text"
                item-value="value"
                label="有償無償"
                v-model="query.isPaid"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="elevation-0"
            item-key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.companyName }}</td>
              <td>{{ props.item.buCode }} - {{ props.item.buName }}</td>
              <td>
                {{ props.item.partnerCode }} - {{ props.item.partnerName }}
              </td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>
                {{ props.item.loadingPortCode }} -
                {{ props.item.loadingPortName }}
              </td>
              <td>
                {{ props.item.dischargePortCode }} -
                {{ props.item.dischargePortName }}
              </td>
              <td>{{ props.item.transportModeCode }}</td>
              <td>{{ props.item.incotermCode }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ warehouses(props.item) }}</td>
              <td>{{ warehouseKeepers(props.item) }}</td>
              <td>{{ props.item.creationDate }}</td>
              <td style="text-align: right">
                {{
                  props.item.grandTotal
                    | currency({ symbol: '', fractionCount: 2 })
                }}
              </td>
              <td>{{ type(props.item) }}</td>
              <td>{{ props.item.isPaid === true ? '有償' : '無償' }}</td>
              <td>{{ props.item.isUsed === true ? '使用済' : '未使用' }}</td>
              <td>{{ props.item.createDate }}</td>
              <td>{{ props.item.updateDate }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <document-invoice-dialog ref="docInvoiceDlg" />
  </v-container>
</template>

<script>
import DocumentInvoiceDialog from './DocumentInvoiceDialog'

export default {
  components: {
    DocumentInvoiceDialog,
  },
  data() {
    return {
      valid: false,
      payment: [
        {
          text: '有償',
          value: true,
        },
        {
          text: '無償',
          value: false,
        },
      ],
      usage: [
        {
          text: '使用済',
          value: true,
        },
        {
          text: '未使用',
          value: false,
        },
      ],
      loading: false,
      results: [],
      selected: [],
      query: {},
      headers: [
        {
          text: this.$t('app.labels.company.name'),
          value: 'companyName',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.bu.name'),
          value: 'buName',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.partner'),
          value: 'partner.name',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.ivNo'),
          value: 'invoiceNo',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.loadingPort'),
          value: 'loadingPort.name',
          sortable: false,
        },
        {
          text: this.$t('app.labels.dischargePort'),
          value: 'dischargePort.name',
          sortable: false,
        },
        {
          text: this.$t('app.labels.transportMode'),
          value: 'transportMode.code',
          sortable: false,
        },
        {
          text: this.$t('app.labels.incoterm'),
          value: 'incoterm.code',
          sortable: false,
        },
        {
          text: this.$t('app.labels.currency'),
          value: 'currency.code',
          sortable: false,
        },
        {
          text: this.$t('app.labels.etd'),
          value: 'etd',
          sortable: false,
        },
        {
          text: this.$t('app.labels.scWarehouse'),
          value: 'scWarehouseId',
          sortable: false,
        },
        {
          text: this.$t('app.labels.warehouseKeeper'),
          value: 'warehouseKeeperId',
          sortable: false,
        },
        {
          text: this.$t('app.labels.creationDate'),
          value: 'creationDate',
          sortable: false,
        },
        {
          text: this.$t('app.labels.grandTotal'),
          value: 'invoiceAmount',
          sortable: false,
        },
        {
          text: 'type',
          value: 'type',
          sortable: false,
        },
        {
          text: '有償无償',
          value: 'isPaid',
          sortable: false,
        },
        {
          text: '使用状況',
          value: 'isUsed',
          sortable: false,
        },
        {
          text: '创建时间',
          value: 'createDate',
          sortable: false,
        },
        {
          text: '更新时间',
          value: 'updateDate',
          sortable: false,
        },
        {
          text: '更新者',
          value: 'updatedBy',
          sortable: false,
        },
      ],
      pagination: {
        page: 1,
      },
    }
  },
  computed: {
    canDelete() {
      return (
        this.selected.map((s) => s.isUsed).filter((s) => s === false).length ===
          this.selected.length &&
        this.selected.filter((s) => s.type === 'FORMALSA' || s.type === 'PRESA')
          .length === 0
      )
    },
  },
  mounted() {
    this.$loadParams()
  },
  methods: {
    type(item) {
      if (item.type === null) {
        return 'SYS'
      } else if (item.type === 'FORMALSA') {
        return '本SA'
      } else if (item.type === 'PRESA') {
        return 'PRESA'
      }
    },
    toPaid() {
      this.$router.push({
        path: '/B0301/new',
        query: {
          type: 'paid',
        },
      })
    },
    toUnpaid() {
      this.$router.push({
        path: '/B0301/new',
        query: {
          type: 'unpaid',
        },
      })
    },
    warehouses(item) {
      return item.scWarehouseNames
    },
    warehouseKeepers(item) {
      return item.scWarehouseManager1Names
    },
    addPartnerToInvoice(invoice) {
      return this.$http.get(`/companies/${invoice.partnerId}`).then((res) => {
        invoice.partner = res.data
        return invoice
      })
    },
    loadInvoiceById(id) {
      return this.$http
        .get(`commercial-invoices/${id}`)
        .then((res) => res.data)
        .then((inv) => {
          return this.addPartnerToInvoice(inv)
        })
    },
    exportInvoicePl() {
      let ids = this.selected.map((s) => s.id).join(',')
      return this.$download(`/commercial-invoices/pdfs?ids=${ids}`)
      /*
      Promise.all(
        this.selected.map(s => {
          return this.loadInvoiceById(s.id)
        })
      ).then(invoices => {
        this.$refs.docInvoiceDlg.popup(invoices)
      })*/
    },
    exportCsv() {
      this.$http
        .get('commercial-invoices', {
          params: {
            ...this.query,
            page: 0,
            size: 999999,
            sort: [
              this.pagination.sortBy,
              this.pagination.descending ? 'desc' : 'asc',
            ].join(','),
          },
        })
        .then((res) => {
          res.data.content.forEach(
            (c) =>
              (c.invoiceAmount = c.items.reduce((t, i) => {
                return (t += i.qty * i.unitPrice)
              }, 0))
          )
          let headers = [
            'partnerName',
            'invoiceNo',
            'loadingPortName',
            'dischargePortName',
            'transportModeCode',
            'incotermCode',
            'currencyCode',
            'etd',
            'warehouses',
            'warehouseKeepers',
            'creationDate',
            'grandTotal',
          ]
          let showHeaders = [
            this.$t('app.labels.partner'),
            this.$t('app.labels.ivNo'),
            this.$t('app.labels.loadingPort'),
            this.$t('app.labels.dischargePort'),
            this.$t('app.labels.transportMode'),
            this.$t('app.labels.incoterm'),
            this.$t('app.labels.currency'),
            this.$t('app.labels.etd'),
            this.$t('app.labels.scWarehouse'),
            this.$t('app.labels.warehouseKeeper'),
            this.$t('app.labels.creationDate'),
            this.$t('app.labels.grandTotal'),
          ]
          let data = res.data.content.map((d) => ({
            ...d,
            warehouses: this.warehouses(d),
            warehouseKeepers: this.warehouseKeepers(d),
          }))
          console.log(data)
          this.$exportTable(data, headers, showHeaders, 'invoices')
        })
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('/commercial-invoices', {
          params: {
            ...this.query,
            ...this.$pageable(),
            sort: 'meta.updateAt,desc',
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.results.forEach(
            (c) =>
              (c.invoiceAmount = c.items.reduce((t, i) => {
                return (t += i.qty * i.unitPrice)
              }, 0))
          )
          this.loading = false
          this.selected = []
        })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    edit() {
      this.$router.push({
        name: 'EditB0301',
        query: {
          id: this.selected[0].id,
        },
      })
    },
    remove() {
      this.$confirm({
        content: this.$t('app.messages.removeConfirm'),
      }).then(() => {
        Promise.all(
          this.selected.map((s) => {
            return this.$http.delete(`/commercial-invoices/${s.id}`)
          })
        ).then(() => {
          this.load()
          this.selected = []
          this.$message('', this.$t('app.messages.removeSuccess'))
        })
      })
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
